export default __webpack_public_path__ + "assets/images/29d64d6a0c438fa153886a578d9afa0b.png";